module.exports = __webpack_public_path__ + "assets/img/premium-star.c27f2553.svg";